var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input-group',[_c('b-form-input',{attrs:{"required":"","type":"number","min":"0","id":"hashrate","placeholder":"Hashrate","step":_vm.step},on:{"blur":_vm.adjust},model:{value:(_vm.coefficient),callback:function ($$v) {_vm.coefficient=$$v},expression:"coefficient"}}),_c('b-form-select',{staticClass:"Flex-35",attrs:{"required":"","options":[
      { value: 0, text: 'H/s' },
      { value: 3, text: 'kH/s' },
      { value: 6, text: 'MH/s' },
      { value: 9, text: 'GH/s' },
      { value: 12, text: 'TH/s' },
      { value: 15, text: 'PH/s' } ]},on:{"change":_vm.adjust},model:{value:(_vm.exponent),callback:function ($$v) {_vm.exponent=$$v},expression:"exponent"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }